module.exports = __webpack_public_path__ + "static/media/nebula-grey.a699ddfb.svg";